export const reduceAdviseSSE = (data, resolveGetAdviseSSE) => {
   let reducedDatas = reduceAdvDatas(data.zones[0].data)
   let returnedData = {
      result: data,
      reducedDatas: reducedDatas,
   }
   resolveGetAdviseSSE(returnedData)
}

/**
 * --------------------------------------------------------------------------
 *  reduceAdvDatas()
 * Reduction de l'objet advise :
 * - supression de l'index str 0
 * - suppression des domains (BB,MOB...)
 * - augmentation avec recoZone et isAdvise
 *
 * @param adviseDatas {} json from Advise webservice
 * --------------------------------------------------------------------------
 */
function reduceAdvDatas(adviseDatas) {
   let tmpDatas = adviseDatas['0']
   let data = {}

   for (let domain in tmpDatas) {
      if (tmpDatas.hasOwnProperty(domain)) {
         let zones = tmpDatas[domain]
         for (let zone in zones) {
            if (zones.hasOwnProperty(zone)) {
               data[zone] = []
               let cpt = 0

               for (let i = 0, len = zones[zone].length; i < len; i++) {
                  const item = zones[zone][i]
                  if (false === ('object' === typeof item && item.hasOwnProperty('response'))) continue
                  if (
                     (item.response.OffersSpecification.offerSpecificationCode !== 'ZZZ' && item.response.OffersSpecification.offerSpecificationCode !== 'DEFAULT') ||
                     zone.search('carrousel') !== -1
                  ) {
                     let offersSpec = item.response.OffersSpecification
                     data[zone][cpt] = offersSpec.Argumentation.argumentationValue
                     data[zone][cpt].recoZone = zone
                     data[zone][cpt].indexSlide = i
                     data[zone][cpt].isAdvise = true
                     data[zone][cpt].advCanal = offersSpec.Argumentation.argumentationName
                     data[zone][cpt].offerSpecificationCode = offersSpec.offerSpecificationCode
                     data[zone][cpt].parentOfferSpecificationCode = offersSpec.parentOfferSpecificationCode
                     cpt++
                  }
               }
            }
         }
      }
   }
   return data
}
